/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyRecoveryOtp} from '../api'

export const useMutationVerifyRecoveryOtp = createReactQueryMutationHook('verifyRecoveryOtp', verifyRecoveryOtp)
